import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { PeriodicalValue } from '../model/PeriodicalValue';

@Injectable({
  providedIn: 'root'
})
export class PeriodicalValueService {
  constructor(private http: HttpClient,
    private configService: ConfigService) {

  }

  public addPeriodicalValue(data: PeriodicalValue): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'PeriodicalValue', data);
  }

  public getPeriodicalValues(id: string): Observable<PeriodicalValue[]> {
    return this.http.get<PeriodicalValue[]>(
      this.configService.PortalWebApiUrl + 'PeriodicalValue/' + id);
  }

  public getPeriodicalValueForDate(id: string, referenceDate: Date): Observable<PeriodicalValue> {
    if(referenceDate == null){
      return this.http.get<PeriodicalValue>(
        this.configService.PortalWebApiUrl + 'PeriodicalValue/forDate/' + id);
    }

    return this.http.get<PeriodicalValue>(
      this.configService.PortalWebApiUrl + 'PeriodicalValue/forDate/' + id + '/' + referenceDate);
  }

  public deleteLastValue(identifier:string): Observable<number> {
    return this.http.delete<number>(
      this.configService.PortalWebApiUrl + 'PeriodicalValue/' +  identifier);
  }
  
}
